import { render } from "./installScriptInstructions.vue?vue&type=template&id=0c9216fb&scoped=true"
import script from "./installScriptInstructions.vue?vue&type=script&lang=js"
export * from "./installScriptInstructions.vue?vue&type=script&lang=js"

import "./installScriptInstructions.vue?vue&type=style&index=0&id=0c9216fb&scoped=true&lang=css"

import exportComponent from "/Users/andrew/Documents/Code/SeoBiz/AdminApp/FrontEnd/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c9216fb"]])

export default __exports__